import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import LibraryService from "../../../../../services/LibraryService/LibraryService"
import SelectInput from "../../../../../components/SelectInput/SelectInput";
import { useRecoilValue } from 'recoil';
import { licensePermission } from '../../../../../recoil-store/recoil-state';

const StepSelectLocalLibrary = ({ publishDetail, setIsRequired, setPublishDetail }) => {
    // Assign initial values to hooks
    const { t } = useTranslation();
    const license = useRecoilValue(licensePermission);
    const [libraries, setLibraries] = useState([]);
    const [selectLibrary, setSelectLibrary] = useState("");

    useEffect(() => {
        let required = true;
        if (publishDetail.publish_detail.library?.id) {
            setSelectLibrary(publishDetail.publish_detail.library.id)
            required = false;
        }
        setIsRequired(required)
        const fetchData = async () => {
            const { data } = await LibraryService.getOwnVendor("local", license.data?.company_name);
            if (Array.isArray(data)) {
                //publishDetail.publish_detail.environment_target.local.status = true;
                setLibraries(data);
            }
        }
        fetchData().then(r => r);
    }, [])

    const changeLibrary = (e) => {
        setSelectLibrary(e.target.value);
        const selectedLib = libraries.find(x => x.id === e.target.value);

        setPublishDetail(oldState => ({
            publish_detail: {
                ...oldState.publish_detail,
                library: {
                    id: e.target.value,
                    name: selectedLib.library_name,
                    library_version_id: selectedLib.library_versions[selectedLib.library_versions.length - 1].id
                }
            }
        }))
        setIsRequired(false);
    }

    return (
        <div style={{ width: '100%' }}>
            <div className="form-element">
                <label>Choose Library</label>
                <SelectInput value={selectLibrary} param="library_name" onChange={changeLibrary} data={libraries} name="library_name" valueKey="id" />
                <div><small>{t("CONTENT.PUBLISH.CHOOSE-YOUR-OWN-LIBRARY-FROM-LOCAL")}</small></div>
            </div>
        </div>
    );
};

export default StepSelectLocalLibrary;
